// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type EditorQuoteIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from editor-quote.svg
 */
export default function EditorQuoteIcon(props: EditorQuoteIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="EditorQuoteIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M3.538 13.745Q3.27 14 2.7 14h-.754q-.57 0-.827-.463-.258-.463.037-1.011l2.04-3.817q.111-.19-.027-.35a.41.41 0 0 0-.322-.16h-.9a.73.73 0 0 1-.525-.227.74.74 0 0 1-.23-.548v-4.65q0-.3.23-.538A.71.71 0 0 1 1.947 2H6.47q.293 0 .524.236.23.236.23.539V7.31a4.7 4.7 0 0 1-.23 1.474 4.1 4.1 0 0 1-.598 1.19l-2.408 3.251q-.184.265-.45.52m7.776 0q-.267.255-.818.255h-.754q-.57 0-.836-.463-.267-.463.045-1.011l2.023-3.817q.11-.19-.019-.35a.39.39 0 0 0-.312-.16h-.901a.73.73 0 0 1-.524-.227.74.74 0 0 1-.23-.548v-4.65q0-.3.22-.538A.7.7 0 0 1 9.743 2h4.504q.294 0 .524.236t.23.539V7.31a4.9 4.9 0 0 1-.22 1.474q-.222.7-.607 1.19l-2.409 3.251q-.183.265-.45.52"
        />
      </g>
    </svg>
  );
}
